import { gameInstance } from '@Game/GameComponent';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { StateMachine } from '@Managers/StateMachine/StateMachine';
import { EGameStates } from './GameStates';
import { StatesDefault } from './GameStatesDefault';
import { StateConditions } from './StateConditions';

export const StateManager = new StateMachine<EGameStates>(StatesDefault, StateConditions, {
    onStateChange: (state) => {
        gameInstance.gameStore.set(EGameStoreKeys.CurrentGameState, state);
    },
    onSubStateChange: (subState) => gameInstance.gameStore.set(EGameStoreKeys.CurrentGameSubState, subState)
});
